import { ISearchParameters, ITableReport } from "./TableInterfaces";
import { DropdownItem } from "./dropdownInterfaces";

/**
 * Sentinel id for the "بدون طبقه" (no asset class) option in the asset-class
 * filter dropdown. It is sent inside `assetTypes` so the backend can return the
 * instruments that have no asset class assigned.
 *
 * NOTE: the backend must interpret this value as "no asset class". If the API
 * expects a different mechanism (e.g. a dedicated flag), only this constant and
 * the wrapper in Requests/assetClass.ts need to change.
 */
export const NO_ASSET_CLASS_ID = "with_no_asset_class";

/** Body of POST /v1/assetclass/table (AssetClassConfig_searchparam) */
export interface IAssetClassSearchParams extends ISearchParameters {
  searchText?: string | null;
  // numeric asset-type ids, plus the NO_ASSET_CLASS_ID sentinel string for "بدون طبقه"
  assetTypes?: (number | string)[];
  instrumentIds?: string[];
}

/** Row of the asset class table (AssetClassConfig_outputobj) */
export interface IAssetClassTableReport extends ITableReport {
  shortInstrumentName?: string;
  fullInstrumentName?: string;
  /** ISIN — the real instrument identifier used for edits */
  instrumentId?: string;
  assetTypeName?: string;
  /** int enum value (no header column) */
  assetType?: number | null;
  searchInstrumentName?: string;
  minimum_volume_permit?: number | null;
  maximum_volume_permit?: number | null;
  price_tick?: number | null;
}

/** Body of POST /v1/assetclass/assettype/update (UpdateAssetTypeDto) */
export interface IUpdateAssetTypeParams {
  instrumentIds: string[];
  assetType: number;
}

/** Body of POST /v1/assetclass/assettype/update-one (UpdateAssetTypeOneDto) */
export interface IUpdateAssetTypeOneParams {
  instrumentId: string;
  assetType: number;
  minimum_volume_permit: number;
  maximum_volume_permit: number;
  price_tick: number;
}

/** Item returned by /v1/assetclass/instruments/dropdown */
export interface IInstrumentDropdownItem extends DropdownItem {
  fullName?: string;
}
